window.$ = jQuery;
import gsap from 'gsap';

const mobileMenu = (function() {
    var isMenuOpen = false;

    $(".hamburger-button__checkbox").on("change", function() {
        if ($(this).is(":checked")) {
            isMenuOpen = true;
            gsap.to(".mobile-menu", { opacity: 1, display: "flex", height: "calc(100svh - 49px)", duration: 0.5, ease: "power2.out", onComplete: setMobileMainMenuHeight});
            window.scrollTo(0, 0);
            $("html, body").addClass("scroll-locked mobile-menu-open");
        } else {
            isMenuOpen = false;
            gsap.to(".mobile-menu", { opacity: 0, display: "none", height: 0, duration: 0.5, ease: "power2.out" });
            $("html, body").removeClass("scroll-locked mobile-menu-open");
        }
    });

    $(".mobile-menu .mobile-menu__primary li.has-submenu").on("click", function(e) {
        e.preventDefault();
        var title = $(this).find("a").text();
        var $secondaryMenu = $(".mobile-menu__secondary-menu[data-secondary='" + title + "']");
        if ($secondaryMenu.length) {
            gsap.to(".mobile-menu__primary", { marginLeft: "-100%", duration: 0.5, ease: "power2.out" });
            gsap.to($secondaryMenu, {opacity: 1,display: "block", duration: 0.5, ease: "power2.out", onComplete: setMobileSecondaryMenuHeight});
        }
    });

    $(".mobile-menu .mobile-menu__secondary__heading").on("click", function(e) {
        e.preventDefault();
        gsap.to(".mobile-menu__primary", { marginLeft: "0", duration: 0.5, ease: "power2.out" });
        gsap.to(".mobile-menu__secondary-menu", {opacity: 0,display: "none", duration: 0.5, ease: "power2.out"});
    });

    $(window).on("resize", function() {
        if (isMenuOpen) {
            setMobileMainMenuHeight();
            setMobileSecondaryMenuHeight();
        }
    });

    function setMobileMainMenuHeight() {
        const mobileFooterHeight = $(".mobile-menu__footer").outerHeight();
        const mainHeaderHeight = $(".main-header").outerHeight();
        const totalHeight = parseInt(mobileFooterHeight) + parseInt(mainHeaderHeight);
        $(".mobile-menu__primary > ul").css("height", "calc(100svh - " + totalHeight + "px)");
    };

    function setMobileSecondaryMenuHeight() {
        const mobileSecondaryHeaderHeight = $(".mobile-menu__secondary__heading:visible").outerHeight(true);
        const mainHeaderHeight = $(".main-header").outerHeight();
        const totalHeight = parseInt(mobileSecondaryHeaderHeight) + parseInt(mainHeaderHeight);
        $(".mobile-menu__secondary__content").css("height", "calc(100svh - " + totalHeight + "px)");
    }

})();

export default mobileMenu;